import React from 'react';
import { useSelector } from 'react-redux';
import styles from './TitleWidget.module.scss';
import { DEFAULT_FONT_SIZE } from './TitleWidgetSettings.jsx';

function TitleWidget({ widgetId }) {
    const alignment = useSelector(state => state.dashboard.widgets[widgetId]?.settings?.alignment) || {};
    const subtitleEnabled = useSelector(state => state.dashboard.widgets[widgetId]?.settings?.subtitle?.enabled);

    return (
        <div
            className={styles['container']}
            style={{
                justifyContent: alignment.vertical || 'start',
                alignItems: alignment.horizontal || 'start'
            }}
        >
            <TextContent widgetId={widgetId} name='content_title' />
            {(subtitleEnabled === null || subtitleEnabled) && <TextContent widgetId={widgetId} name='subtitle' />}
        </div>
    )
}

function TextContent({ widgetId, name }){
    const attrs = useSelector(state => state.dashboard.widgets[widgetId]?.settings?.[name]) || {};
    const truncateStyle = attrs.truncate === undefined || attrs.truncate != null ? {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: attrs.truncate || 1,
        overflow: 'hidden',
    } : {};

    return (
        <div 
            style={{
                fontSize: `clamp(1cqw, ${attrs.fontSize || DEFAULT_FONT_SIZE[name]}px, 50cqw)`,
                fontFamily: attrs.fontFamily || 'Arial, Helvetica, sans-serif',
                color: attrs.color,
                ...truncateStyle
            }}
        >
            {attrs.text}
        </div>
    )
}

export default TitleWidget;
